const GetValueOptionsUrl = `/admin/api/value_options`;

export { GetValueOptionsUrl };